import React, { useState } from "react";
import ConfirmationDialog from "./ConfirmationDialog";
import { useGlobalState } from "../contexts/GlobalStateContext";

const UpdatePasswordModal = ({ onClose }) => {
  const [newPassword1, setNewPassword1] = useState("");
  const [newPassword2, setNewPassword2] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [notice, setNotice] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const {logOut, resetGlobalState} = useGlobalState();

  const resetFields = () => {
    setNewPassword1("");
    setNewPassword2("");
    setOldPassword("");
  };

  const handlePreConfirm = () => {
    setNotice("");

    if (newPassword1 !== newPassword2) {
      setNotice("New passwords do not match.");
      return;
    }

    if (!newPassword1 || !newPassword2 || !oldPassword) {
      setNotice("All fields are required.");
      return;
    }

    // All validations passed – show confirmation dialog
    setShowConfirm(true);
  };

  const updatePassword = () => {
    const formData = new FormData();
    formData.append("old_password", oldPassword);
    formData.append("new_password", newPassword1);

    fetch("/php/update_password.php", {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setNotice(data.message);
          resetFields();

          setTimeout(() => {
            setNotice("");
            onClose();
          }, 1000);
        } else if (data.status === "error"){
          logOut();
          resetGlobalState();
        } else {
          setNotice(data.message);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setNotice("An error occurred. Please try again.");
      });
  };

  return (
    <>
      <div class="update-setting-modal" style={{ display: "block" }}>
        <div className="setting-content">
          <div id="comments-header">
            <span id="modal-title">Update Password</span>
            <span className="close" onClick={onClose}>
              &times;
            </span>
          </div>
          <div className="notice" style={{ color: notice.includes("successfully") ? "green" : "red" }}>
            {notice}
          </div>
          <input
            type="password"
            className="fullTextbox"
            placeholder="Enter new password"
            value={newPassword1}
            onChange={(e) => setNewPassword1(e.target.value)}
            autoComplete="new-password"
          />
          <input
            type="password"
            className="fullTextbox"
            placeholder="Re-enter new password"
            value={newPassword2}
            onChange={(e) => setNewPassword2(e.target.value)}
            autoComplete="new-password"
          />
          <input
            type="password"
            className="fullTextbox"
            placeholder="Enter your old password"
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
            autoComplete="current-password"
          />
          <button
            style={{ backgroundColor: "#3DDC84" }}
            className="confirm"
            onClick={handlePreConfirm}
          >
            Confirm
          </button>
        </div>
      </div>

      <ConfirmationDialog
        show={showConfirm}
        action="save"
        onConfirm={() => {
          setShowConfirm(false);
          updatePassword();
        }}
        onCancel={() => setShowConfirm(false)}
      />
    </>
  );
};

export default UpdatePasswordModal;
